import { FormattedMessage, FormattedNumber } from 'react-intl'

import { cn } from '@gto/ui/cn'
import { Skeleton } from '@gto/ui/skeleton'
import type { TypographyProps } from '@gto/ui/typography'
import { Typography } from '@gto/ui/typography'

import { IconEdgeCoin, IconExcellenceCoin } from '@/assets/icons'

export type EdgeBalanceProps = {
  balance: string | number
  iconSize?: number
  withSubtitle?: boolean
  typoProps?: TypographyProps
  withRounding?: boolean
  loading?: boolean
  coinType?: 'edge' | 'excellence'
}

export const EdgeBalance = ({
  balance,
  iconSize = 24,
  withSubtitle = false,
  typoProps = {},
  withRounding = false,
  loading = false,
  coinType = 'edge',
}: EdgeBalanceProps) => {
  const { className: typoClassName, ...typoRest } = typoProps
  const CoinIcon = coinType === 'excellence' ? IconExcellenceCoin : IconEdgeCoin

  return (
    <div className="flex items-center gap-2">
      <CoinIcon
        height={iconSize}
        width={iconSize}
      />
      <div className="flex flex-col">
        {loading ? (
          <Skeleton
            variant="text"
            width={30}
          />
        ) : (
          <>
            <Typography
              variant="subtitle1"
              className={cn(
                'font-semibold text-cyan-300',
                withSubtitle ? 'leading-[1]' : 'leading-[1.6]',
                typoClassName,
              )}
              {...typoRest}
            >
              <FormattedNumber
                {...((withRounding || Number(balance) > 1_000_000) && {
                  compactDisplay: 'short',
                  maximumFractionDigits: 1,
                  notation: 'compact',
                })}
                value={Number(balance)}
              />
            </Typography>
            {withSubtitle && (
              <Typography
                className="text-cyan-900"
                variant="body4"
              >
                <FormattedMessage id="common.labels.balance" />
              </Typography>
            )}
          </>
        )}
      </div>
    </div>
  )
}
